<ng-template #template>
  <div class="pb-5" [ngClass]="['col-lg-' + width]">
    <div class="card" style="background-color: #0e0e29">
      <div class="card-body">
        <h3 *ngIf="data" style="color: white">{{ data.title }}</h3>
        <div style="display: block" style="position: relative">
          <canvas
            baseChart
            #chart
            [datasets]="chartData"
            [labels]="chartLabels"
            [options]="chartOptions"
            [colors]="chartColors"
            [legend]="chartLegend"
            [chartType]="chartType"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</ng-template>
